import axios from 'axios';

export default {

    //Permet de récuperer la liste des concours
    get() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours');
    },

    //Permet de récupérer la liste des concours pour les afficher dans les challenges
    getCards(userId, length = null, startIndex = null, all = null) {
        let params = '';
        if(length != null){
            params += '?length=' + length;
            if(startIndex != null){
                params += '&start_index=' + startIndex;
            }
            if(all != null){
                params += '&all=' + all;
            }
        } else {
            if(all != null){
                params += '?all=' + all;
            }
        }

        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/card' + params);
    },

    //Permet de récuperer les informations d'accueil sur le concours sélectionné
    getHome(userId, concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + concoursId + '/' + userId + '/home');
    },

    //Permet de récuperer le résumé d'un concours
    getResume(userId, concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/resume/' + concoursId);
    },

    //Permet de récuperer la destination du concours
    getDestination(concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/destination/' + concoursId + '/data');
    },

    //Permet de récuperer la liste des excursions du concours
    getExcursionList(concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/excursions/' + concoursId + '/list');
    },

    //Permet de récuperer les données d'une excursion
    getExcursionData(concoursId, excursionId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/excursions/' + concoursId + '/data/' + excursionId);
    },

    //Permet de récuperer le classement des utilisateurs sur une excursion
    getExcursionRanking(userId, concoursId, excursionId, all = false) {
        //Si all est à true alors en renvoie tous les utilisateurs et pas seulement ceux rattaché à l'utilisateur courrant
        let params = "?all=" + all;
        return axios.get(process.env.VUE_APP_API_URI + '/api/excursions/' + concoursId + '/data/' + excursionId + '/classement/' + userId + params);
    },

    //Retourne les actualités d'un concours
    getNewsList(concoursId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/news/' + concoursId + '/list');
    },

    //Retourne les données d'une actualité
    getNewsDetail(newsId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/news/' + newsId + '/data');
    },

    //Retourne le réglement du concours pour le type d'utilisateur renseigné (ex : CONFIG_RCR)
    getReglement(concoursId, typeUser){
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + concoursId + '/reglement/' + typeUser);
    },

    //Permet de récuperer les résultats au concours d'un utilisateur
    getResult(userId, concoursId, date = null, filtre = 'month') {
        let param = '?filtre='+filtre;
        if(date != null){
            param += '&date='+date;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/result/' + concoursId + param);
    },

    //Permet de récuperer le classement des utilisateurs sur un concours
    getClassement(userId, concoursId, date = null, type = null, all = false) {
        let param = '?all='+all;
        if(date != null){
            param += '&date='+date;
        }
        if(type != null){
            param += '&type='+type;
        }

        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/result/' + concoursId + '/classement' + param);
    },

    //Permet de récuperer les dates des résulttats d'un concours
    getResultDate(concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/result/' + concoursId + '/dates');
    },

    //Permet de récuperer les types d'utilisateurs à qui on a acces sur un concours
    getResultTypes(concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/result/' + concoursId + '/types');
    },

    getHomeFirstModal(userId, concoursId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/home/' + concoursId + '/modal');
    }

}
